import { render, staticRenderFns } from "./thankyou-message.vue?vue&type=template&id=7ff7c1c0&scoped=true&"
import script from "./thankyou-message.vue?vue&type=script&lang=js&"
export * from "./thankyou-message.vue?vue&type=script&lang=js&"
import style0 from "./thankyou-message.vue?vue&type=style&index=0&id=7ff7c1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff7c1c0",
  null
  
)

export default component.exports